import { nanoid } from "nanoid";
import { DashboardFilterInstance } from "../../../context/FiltersProvider/types";
import { FilterItem, FiltersFormState, GroupFilter, RowFilter } from "../types";

export const normalizeValue = (value?: string | string[]) => {
	if (value == null) return undefined;
	return value;
};

// Converts simple dashboard filters (chip UI) into the advanced form structure.
//
// Main purpose:
// - Used when switching from SIMPLE mode → ADVANCED mode
// - Transforms flat filters into a tree-based form state
//
// Behavior notes:
// - Every dashboard filter becomes a "row" node
// - Rows are wrapped into a nested AND group
// - The nested group is placed inside the root group
// - This allows the converted filters to behave like a removable/editable block
export const simpleToAdvancedFormState = (filters: DashboardFilterInstance[]): FiltersFormState => {
	const rows: FilterItem[] = filters.map(
		(f): FilterItem => ({
			type: "row",
			value: {
				id: f.id,
				filter: f.filterId,
				operator: f.operator,
				value: normalizeValue(f.value),
			} as RowFilter,
		})
	);

	const nestedGroup: FilterItem = {
		type: "group",
		value: {
			id: nanoid(),
			rowOperator: "and",
			rows,
		},
	};

	const rootGroup: GroupFilter = {
		id: "root",
		rowOperator: "and",
		rows: [nestedGroup],
	};

	return {
		filters: [
			{
				type: "group",
				value: rootGroup,
			},
		],
	};
};
